import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormControl, Validators, FormGroup} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';

import {Store} from '@ngrx/store';
import {ConfigService} from '@cosbeni/auth';
import {FormHelperService} from '../services/form-helper.service';
import {ToasterConfig, ToasterService} from 'angular2-toaster';

import {LotasConfig} from '../config/lotas.config';
import {DataService} from '@cosbeni/database';

/**
 * パスワード再設定の依頼フォーム (issue #170)。
 *
 * 旧 `/rest/user/reset` は認証なしで任意アカウントのパスワードを書き換えられたため削除され
 * (issue #169)、`/rest/public/lotas/password/request` に置き換わった。
 *
 * サーバはユーザの有無にかかわらず同じ応答を返す (アカウント列挙の防止) ので、画面側も
 * 成否で文言を変えず、常に同じ案内を出す。
 */
@Component({
    selector: 'app-dashboard',
    styleUrls: ['../../scss/style.scss', '../../scss/vendors/toastr/toastr.scss', 'reset-password.component.css'],
    templateUrl: 'reset-password.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent implements OnInit {
    account: any = {username: ''};
    form: FormGroup;
    sent: boolean = false;
    toasterconfig: ToasterConfig =
        new ToasterConfig({
            tapToDismiss: true,
            timeout: 5000,
            toastContainerId: 1
        });

    constructor(public store: Store<any>, public router: Router, public formHelper: FormHelperService, public formBuilder: FormBuilder, public dataService: DataService, public config: ConfigService, public toasterService: ToasterService, public http: HttpClient) {}

    ngOnInit() {
        this.form = this.formBuilder.group({
            username: new FormControl('', [Validators.required, Validators.minLength(3)]),
        });
    }

    reset(value: any) {
        this.http.post(LotasConfig.SERVER_URL + '/rest/public/lotas/password/request', {
            login: value.username
        }).subscribe(() => {
                this.done();
            },
            () => {
                // 応答が来なかった場合も文言は変えない (該当ユーザの有無を推測させない)
                this.done();
            },
        );
    }

    private done() {
        this.sent = true;
        this.toasterService.pop('info', '受け付けました', '登録メールアドレス宛に案内を送りました。');
    }

}
